var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-swiper"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.list),function(item,index){return _c('swiper-slide',{key:index,staticClass:"vip-swiper-slide",class:{'swiper-no-swiping' :_vm.touchVisible},style:(_vm.style)},[_c('img',{style:(_vm.style),attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }